import type { ReactElement } from 'react';
import React from 'react';
import { useGetRouteToIssuerPage } from '../../../../app/get-route-to-page';
import { Page } from '../../../../app/page-url-path';
import { MediaType } from '../../../../component_library/components/Card/Card';
import { DataElementId } from '../../../../constants/data-element-tracking-ids';
import type { IArticleData } from '../../../../dotcms/dotcms-models/resources/dotcms-article';
import type { ILinkData } from '../../../../dotcms/dotcms-models/dotcms-link';
import { UrlRouteToken } from '../../../../app/router-utils';
import ResourcePreviewCard from './resource-preview-card';

interface IProps {
  renderCardWrapper?: (children: ReactElement) => ReactElement;
  article: IArticleData;
  articleLink?: ILinkData;
}

const ArticlePreviewCard: React.FC<IProps> = ({
  renderCardWrapper,
  article,
  articleLink,
}) => {
  const articleUrl =
    useGetRouteToIssuerPage(Page.RESOURCE_LIBRARY_ID, {
      [UrlRouteToken.LIBRARY_RESOURCE_ID]: article.urlTitle,
    }) ?? articleLink?.url;

  const media =
    !article.image && !article.imageHtml && article.videoUrl
      ? {
        type: MediaType.Video,
        url: article.videoUrl ?? '',
        html: undefined,
      }
      : {
        type: MediaType.Image,
        url: article.image?.url ?? '',
        html: article.imageHtml,
      };

  return (
    <ResourcePreviewCard
      dataElementId={DataElementId.ARTICLE_PREVIEW_CARD}
      renderCardWrapper={renderCardWrapper}
      resourceType={article.resourceType}
      resourceLink={
        articleLink && articleUrl
          ? {
            linkText: articleLink.text,
            linkTo: articleUrl,
            dataElementId: DataElementId.ARTICLE_PREVIEW_READ_MORE,
          }
          : undefined
      }
      media={media}
      title={article.header}
      description={article.descriptionHtml}
    />
  );
};

export default ArticlePreviewCard;
